<well-page-title title="{{'platform-administration.company.legal-entity.title' | translate}}">
</well-page-title>
<div class="card mx">
    <well-platform-legal-entity-inputs
            [platformLegalEntityDTO]="data"
            (submitForm)="onSubmit($event)"
            (cancelForm)="onCancel()" data-testid="platform-legal-entity-inputs-input">
    </well-platform-legal-entity-inputs>
</div>



